<template>
  <div id="userLogin">
    <div>
      <h2>
        <!-- <svg class="icon" aria-hidden="true">
          <use xlink:href="#se-icon-elephant"></use>
        </svg> -->
        <span>移动智能诊断专用</span>
      </h2>
      <form>
        <div>
          <keep-alive>
            <se-autocomplete v-model="iccid" :fetchsuggestions="querySearch" @select="handleSelect"
              placeholder="请输入诊断卡号"></se-autocomplete>
          </keep-alive>
        </div>
        <div class="formLine">
          <mt-button type="primary" style="background:#0066FF" size="large" @click.prevent="userQuerySIM">智能诊断</mt-button>
        </div>
      </form>
    </div>

    <p style="text-align: center;font-size: 10px;margin-top:1rem;color:red">提醒：诊断成功后 请打开手机飞行模式一下或者重启手机，即可正常使用。</p>
    <!-- <img
      style="width: 100%; margin-top: 1rem;"
      src="@/assets/advertising3.jpg"
      alt=""
      @click="goto('http://szyanyun.com/download.html')"
    /> -->
    <!-- <button class="download" @click="goto('http://szyanyun.com/download.html')" >点击下载</button> -->

    <!-- <Advertisement></Advertisement> -->
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
import SeAutocomplete from "@/components/SeAutocomplete";
import Advertisement from "@/components/Advertisement";
export default {
  components: { SeAutocomplete, Advertisement },
  data() {
    return {
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
    };
  },
  methods: {
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData("iccidList");
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll;
      cb(results);
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0;
      };
    },
    handleSelect(item) {
      this.iccid = item;
    },
    userQuerySIM() {
      // Dialog({ message: '系统维护中' });
      // return;
      if (!this.iccid || this.iccid == "") {
        Dialog.alert({ title: "提示", message: "请输入ICCID号" });
        return false;
      }

      let recordLoginText = this.iccid; //存放用户登录时输入的文本，将用于首页显示

      let data = {
        requestId: this.iccid,
        code: this.code,
        iccid: this.iccid,
        isCode: 1
      };
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code == 200) {
          let record = res.data.data;
          let iccid = record.iccid;
          localStorage.setItem("isCode", true);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("virtualNo", record.virtualNo);

          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          // this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);

          this.$store.state.intoNo = record.intoNo;
          this.$store.state.iccid = record.iccid;
          sessionStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("iccid", iccid);

          wxRequest("sim/is/have/price", { iccid: iccid }, "get").then(res => {
            if (res.data.code != 200) {
              Dialog.confirm({ title: '优惠提醒', message: '当前卡尚未享受优惠，请先点击确定享受优惠后再来诊断' }).then(action => {
                if (action == 'confirm') {
                  if (record.basePkgGroup == '1549295580465852416') { //悟空卡
                    this.$router.replace("/user/simOpenWu");
                  } else if (record.basePkgGroup == '1549295498467209216') { //乐享卡
                    this.$router.replace("/user/simOpenLe");
                  }
                }
              })
            } else {
              wxRequest("sim/bindIccid/appid", data, "get").then((res) => {
                if (res.data.data == true) {
                  wxRequest("wxAuth/oneButton/user", data, "post").then((res) => {
                    if (res.data.code == 200) {
                      Dialog.alert({ title: "诊断成功", message: '诊断成功！请飞行模式一下或者重启手机便可正常使用！' });
                    } else if (res.data.code == 882) {
                      Dialog.confirm({ title: '实名登记提醒', message: res.data.message }).then(action => {
                        if (action == 'confirm') {
                          this.$router.replace("/user/loginAuth");
                        }
                      })
                    } else if (res.data.code == 881) {
                      Dialog.confirm({ title: '套餐续费提醒', message: res.data.message }).then(action => {
                        if (action == 'confirm') {
                          // on confirm
                          this.$router.push({
                            path: '/user/recharge',
                            query: {
                              iccid: record.iccid
                            }
                          });
                        }
                      })
                    }
                    else {
                      Dialog.alert({ title: "提示", message: res.data.message });
                    }
                  });








                } else {
                  Dialog.alert({ title: "提示", message: '授权失败 请重新扫码登录！' });
                }
              });

            }
          })







        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
          return;
        }
      })

    },

    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    goto(path) {
      //广告点击统计
      window.location.href = path;
    },
  },
  created() {
    var source = "wx18b33905435d410b";
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);
    var appid = source ? source : process.env.VUE_APP_APPID;

    console.log(appid);
    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb4bff16244869bed&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      this.iccid = localStorage.getItem("recordLoginText");

      //自动登录
      // if(this.iccid){
      //     this.userQuerySIM();
      // }
    }
    this.$store.commit("setIsHeadquarterAppid", "true");
    localStorage.setItem("isHeadquarterAppid", true);
  },

  mounted() { },

  beforeDestory() { },
};
</script>

<style lang="less" scoped>
.download {
  position: relative;
  top: -63px;
  background: #ff9c3c;
  border: none;
  padding: 7px 13px;
  border-radius: 25px;
  font-size: 12px;
  color: #fff;
  left: 20%;
}
</style>
